import {resolveToken} from '@sail/engine';
import {assignTokens, darkModeTokenOverrides, tokens} from '@sail/ui';
import {getLightnessSign} from '@sail/utils';

const LIGHT_MODE_TEXT_COLOR = resolveToken(
  tokens.color.text,
  assignTokens(tokens, {}),
) as string;
const DARK_MODE_TEXT_COLOR = resolveToken(
  tokens.color.text,
  darkModeTokenOverrides(),
) as string;

/**
 * Determines the appropriate text color for accessibility based on background color.
 * Uses WCAG-compliant contrast ratios via getLightnessSign.
 *
 * @param backgroundColor - The background color to analyze
 * @returns The appropriate text color for accessibility
 */
export function getAccessibleTextColor(backgroundColor: string): string {
  const useDarkModeText = getLightnessSign(backgroundColor) === 1;
  // lightnessSign === 1 means dark background
  // lightnessSign === -1 means light background

  return useDarkModeText ? DARK_MODE_TEXT_COLOR : LIGHT_MODE_TEXT_COLOR;
}
